/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_NameInputs */

const th_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const en_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their name`)
};

const ja_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

const zh_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他的姓名`)
};

const es_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su nombre`)
};

const pt_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dele`)
};

const id_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namanya`)
};

const fr_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son nom`)
};

const tl_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan niya`)
};

const vi_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên của họ`)
};

const ko_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수 이름`)
};

const de_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sein Name`)
};

const ru_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Его имя`)
};

const tr_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adı`)
};

const it_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il suo nome`)
};

const pl_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jego imię`)
};

const uk_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Його ім'я`)
};

const hi_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उनका नाम`)
};

const ar_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسمه`)
};

const ms_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namanya`)
};

const bn_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তাঁর নাম`)
};

const zh_tw2_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他的姓名`)
};

const zh_hk2_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他的姓名`)
};

const ur_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ان کا نام`)
};

const fa_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نامش`)
};

const sw_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina lake`)
};

const nl_player_name = /** @type {(inputs: Player_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn naam`)
};

/**
* | output |
* | --- |
* | "Their name" |
*
* @param {Player_NameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_name = /** @type {((inputs?: Player_NameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_NameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_name(inputs)
	if (locale === "ja") return ja_player_name(inputs)
	if (locale === "zh") return zh_player_name(inputs)
	if (locale === "es") return es_player_name(inputs)
	if (locale === "pt") return pt_player_name(inputs)
	if (locale === "id") return id_player_name(inputs)
	if (locale === "fr") return fr_player_name(inputs)
	if (locale === "tl") return tl_player_name(inputs)
	if (locale === "vi") return vi_player_name(inputs)
	if (locale === "ko") return ko_player_name(inputs)
	if (locale === "de") return de_player_name(inputs)
	if (locale === "ru") return ru_player_name(inputs)
	if (locale === "tr") return tr_player_name(inputs)
	if (locale === "it") return it_player_name(inputs)
	if (locale === "pl") return pl_player_name(inputs)
	if (locale === "uk") return uk_player_name(inputs)
	if (locale === "hi") return hi_player_name(inputs)
	if (locale === "ar") return ar_player_name(inputs)
	if (locale === "ms") return ms_player_name(inputs)
	if (locale === "bn") return bn_player_name(inputs)
	if (locale === "zh-TW") return zh_tw2_player_name(inputs)
	if (locale === "zh-HK") return zh_hk2_player_name(inputs)
	if (locale === "ur") return ur_player_name(inputs)
	if (locale === "fa") return fa_player_name(inputs)
	if (locale === "sw") return sw_player_name(inputs)
	if (locale === "nl") return nl_player_name(inputs)
	return en_player_name(inputs)
});